import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const BackgroundWrapper = styled(FlexColumn)<{
  backgroundGradient?: string;
}>`
  align-items: center;
  background: ${({ backgroundGradient }) =>
    backgroundGradient ? backgroundGradient : undefined};

  padding: 40px 24px;

  ${QUERIES.largeTabletAndUp} {
    padding: 48px;
  }

  ${QUERIES.laptopAndUp} {
    padding: 56px 48px;
  }

  ${QUERIES.smallDesktopAndUp} {
    padding: 80px 160px;
  }
`;

export const SectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;

  ${QUERIES.largeTabletAndUp} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    min-width: 100%;
    align-items: center;
  }
`;
